import { VEHICLE_ID_RE } from "./api";

/**
 * The vehicle id in a scanned bike QR, like the Pony apps read it: a Pony sticker is a URL
 * (`https://getapony.com/app/scan?id=E028671`, older ones `?bike_id=`), else the text is the number.
 */
export function vehicleIdFromQr(raw: string): string | undefined {
  const text = raw.trim();
  let id = text;
  if (/^https?:\/\//i.test(text)) {
    let url: URL;
    try {
      url = new URL(text);
    } catch {
      return undefined;
    }
    id = url.searchParams.get("id") ?? url.searchParams.get("bike_id") ?? "";
  }
  id = id.trim().toUpperCase();
  return id && VEHICLE_ID_RE.test(id) ? id : undefined;
}
